import { useEffect, useRef, useState } from 'react';

interface IParams {
  open: boolean;
}

export const useHeightController = ({ open }: IParams) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    const footerEl = footerRef.current;

    if (!open || !footerEl) {
      return;
    }

    setFooterHeight(footerEl.offsetHeight);
  }, [open]);

  return { footerRef, footerHeight };
};
